import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { RadioComponent } from '../radio/radio.component';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  imports: [ButtonDirective, RadioComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonComponent {
  @Input() checked = false;
  @Input() hasIcon = false;
  @Input() simple = false;
  @Input() checkStyle: 'check' | 'radio' = 'check';
  @Input() name = 'DONTREPORT';
  @Input() location: string;
  @Input() analyticsExtra: { [key: string]: string | number | boolean };
  @Input() spacing = 'full';
  @Input() fullWidth: boolean;
  @Input() activeColor: string;
  @Input() height = '1';
}
